import dayjs from '~/utils/dayjsConfig';

class FBMOrdersV2Helpers {
    constructor() {}

    /**
     * Filters line hauls for change line haul modals
     * @param {Array} lineHauls - The line hauls to filter
     * @returns {Array} - The filtered line hauls
     */
    filterLineHaulsForChangeLineHaulModals(lineHauls) {
        const dayToIndex = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };
        const todayIndex = dayjs().day();
        // Get Thursday's index (4)
        const thursdayIndex = dayToIndex['thursday'];
        // If we're past Thursday, return nothing;
        if (todayIndex > thursdayIndex) {
            return [];
        }
        const filtered = lineHauls.filter((lineHaul) => {
            // Get the arrival day's index from the day name
            const arrivalDayIndex = dayToIndex[lineHaul.arrivalDay.toLowerCase()];

            // Check if arrival day is between today and target Thursday
            return arrivalDayIndex >= todayIndex && arrivalDayIndex <= thursdayIndex;
        });
        return filtered;
    }
}

export { FBMOrdersV2Helpers };
